/** @module others/renderOrderMenu */

import React from "react";
import { Menu, message } from "react-aiot";
import { i18n, IS_DARKMODE, rmlOpts } from "../util";
import { applyToAttachmentsBrowser } from "../hooks/sortable";
const {
  Item,
  SubMenu,
  Divider
} = Menu;

/**
 * An element rendering sortables for the popup menu.
 *
 * @returns React.Element[]
 */
const createSortables = (sortables, select, selectText) => Object.keys(sortables).map(key => /*#__PURE__*/React.createElement(Item, {
  key: key
}, sortables[key], " ", select === key && /*#__PURE__*/React.createElement("strong", null, "(", selectText, ")")));

/**
 * Apply an order to a tree node object and afterwards reload the view.
 *
 * @this AppTree
 */
async function applyOrder(selected, key, automatically) {
  if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
    this.setState({
      showProFeature: "order-content"
    });
  } else {
    const hide = message.loading(i18n("orderLoadingText", {
        name: selected.title
      })),
      {
        attachmentsBrowser
      } = this;
    await selected.applyOrder(key, automatically);

    // Apply props to backbone model
    applyToAttachmentsBrowser(attachmentsBrowser, selected);
    this.handleReload();
    hide();
  }
}

/**
 * When clicking on a menu item in the order menu popup.
 *
 * @this AppTree
 */
async function handleClick(_ref) {
  let {
    key,
    keyPath
  } = _ref;
  const path = keyPath.reverse(),
    {
      selected
    } = this.props.store,
    _applyOrder = applyOrder.bind(this);
  if (path[0] === "dnd") {
    this.handleOrderClick();
  } else if (path[0] === "applyOnce") {
    // Apply sorting once
    _applyOrder(selected, key);
  } else if (path[0] === "applyAutomatically") {
    _applyOrder(selected, key, true);
  } else if (key === "reset") {
    _applyOrder(selected, "original");
  } else if (key === "resetAutomatically") {
    _applyOrder(selected, "deactivate");
  } else if (key === "applyReindex") {
    _applyOrder(selected, "reindex");
  } else if (key === "applyResetLast") {
    _applyOrder(selected, "last");
  }
}

/**
 * Render the order menu.
 *
 * @type React.Element
 */
export default function () {
  const {
      store
    } = this.props,
    {
      selected,
      sortables
    } = store,
    isSortable = selected && selected.properties && selected.contentCustomOrder !== 2;
  if (!isSortable) {
    return /*#__PURE__*/React.createElement(Menu, {
      style: {
        visibility: "hidden"
      }
    });
  }
  return /*#__PURE__*/React.createElement(Menu, {
    onClick: handleClick.bind(this),
    theme: IS_DARKMODE ? "dark" : "light"
  }, !selected.orderAutomatically && /*#__PURE__*/React.createElement(Item, {
    key: "dnd"
  }, i18n("orderByDnd")), selected.contentCustomOrder !== 0 && /*#__PURE__*/React.createElement(Item, {
    key: "reset"
  }, i18n("resetOrder")), !selected.orderAutomatically && /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyOnce",
    title: i18n("applyOrderOnce"),
    disabled: selected.orderAutomatically
  }, sortables && createSortables(sortables, selected.lastOrderBy, i18n("last"))), selected.orderAutomatically && /*#__PURE__*/React.createElement(Item, {
    key: "resetAutomatically",
    disabled: selected.contentCustomOrder === 0
  }, i18n("deactivateOrderAutomatically")), /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyAutomatically",
    title: i18n("applyOrderAutomatically")
  }, sortables && createSortables(sortables, selected.orderAutomatically && selected.lastOrderBy, i18n("latest"))), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Divider, null), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Item, {
    key: "applyReindex"
  }, i18n("reindexOrder")), selected.contentCustomOrder === 1 && /*#__PURE__*/React.createElement(Item, {
    key: "applyResetLast"
  }, i18n("resetToLastOrder")));
}